var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "mainUl" },
    _vm._l(_vm.flowInfo, function(item, index) {
      return _c(
        "li",
        {
          key: index,
          class: {
            next: index !== _vm.flowInfo.length - 1 && +_vm.orderFlag === 1
          }
        },
        [
          [
            _c(
              "div",
              { staticClass: "people" },
              [
                item.imgPath
                  ? _c("img", {
                      attrs: { src: _vm.fileOperShow(item.imgPath) }
                    })
                  : [
                      _c("img", {
                        attrs: { src: "/images/web/p-default1.png" }
                      })
                    ]
              ],
              2
            ),
            _c(
              "p",
              {
                staticClass: "p1",
                attrs: {
                  title:
                    item.partyName || item.corpUserName || _vm.getName(item)
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      item.partyName ||
                        item.corpUserName ||
                        _vm.getName(item) ||
                        item.name
                    ) +
                    "\n      "
                )
              ]
            )
          ],
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: item.hasSend,
                  expression: "item.hasSend"
                }
              ]
            },
            [
              _c(
                "p",
                {
                  class: [
                    "p2",
                    {
                      danger: item.flowStatus === 2,
                      agree: item.flowStatus === 1
                    }
                  ]
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.txtChange(item.flowStatus)) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "p",
                {
                  staticClass: "p-date",
                  staticStyle: { "margin-bottom": "10px" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("format")(item.flowTime)) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "el-tooltip",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.flowStatus === 2,
                      expression: "item.flowStatus === 2"
                    }
                  ],
                  attrs: { effect: "dark", placement: "top-start" }
                },
                [
                  _c(
                    "p",
                    {
                      staticStyle: { width: "200px", "line-height": "1.5" },
                      attrs: { slot: "content" },
                      slot: "content"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.refuseReason || "无") +
                          "\n        "
                      )
                    ]
                  ),
                  _c("span", { staticStyle: { cursor: "default" } }, [
                    !_vm.isInDingTalk
                      ? _c("span", { staticClass: "danger" }, [
                          _vm._v(" 拒绝原因 ")
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              !_vm.showTipBtn() &&
              item.flowStatus === 0 &&
              _vm.prevItemFn(item) &&
              !_vm.isInDingTalk
                ? _c(
                    "p",
                    { staticClass: "btn1" },
                    [
                      !item.tip && _vm.timeOverFn(item)
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "mini btn-margin btn-red-border" },
                              on: {
                                click: function($event) {
                                  return _vm.handleTip(item)
                                }
                              }
                            },
                            [_vm._v("提醒")]
                          )
                        : _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini btn-margin btn-gray",
                                type: "info"
                              }
                            },
                            [_vm._v("已提醒")]
                          )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48d12bba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d12bba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/approval-process/index.vue
// module id = xLFD
// module chunks = 2 3 7 12 13 16 30 33 75 98 127